import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./locales/locales.js";
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources: resources,
    fallbackLng: "en",
    detection: {
        order: ["querystring", "cookie", "localStorage", "navigator"],
        caches: ["localStorage", "cookie"],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
    },
    interpolation: {
        escapeValue: false,
    },
    //debug: env.PUBLIC_I18N_DEBUG
    defaultNS: "translation",
    ns: ["translation"],
    react: {
        useSuspense: true,
    },
});
export default i18n;
